import { render, staticRenderFns } from "./productComparison.vue?vue&type=template&id=bce2ab6e&scoped=true&"
import script from "./productComparison.vue?vue&type=script&lang=js&"
export * from "./productComparison.vue?vue&type=script&lang=js&"
import style0 from "./productComparison.vue?vue&type=style&index=0&id=bce2ab6e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce2ab6e",
  null
  
)

export default component.exports